module.exports = __webpack_public_path__ + "static/design07-32f513b75b350f329cb27cb0597ac74c.jpg";